/*ěščřžýáíéúů*/

var $header = $("header.site-header");
var $footer = $("footer.site-footer");
var $menuBtn = $header.find(".site-header__menu-btn");
var $mobileNav = $header.find(".site-header__nav-wrapper");
var $clickPlaceholder = $(".click-body-placeholder");
var $headerSearch = $(".header__search");
var $hideNavBreakpoint = 890;

function openNav() {
    $menuBtn.addClass("active");
    $mobileNav.slideDown(400);
}

function hideNav() {
    $menuBtn.removeClass("active");
    $mobileNav.slideUp(400);
}

let mobileMenuBreakpoint = 0;

const cssVars = () => {
    const doc = document.documentElement;
    const headerOffset = window.innerWidth < 600 ? 40 : 70;
    doc.style.setProperty("--site-header-height", ($header.innerHeight() + headerOffset) + "px");
    const $topbar = $header.find(".site-header-v2__topbar");
    doc.style.setProperty("--topbar-height", ($topbar.length ? $topbar.outerHeight() : 0) + "px");
    if ($("#wpadminbar").length) {
        doc.style.setProperty("--adminbar-height", $("#wpadminbar").innerHeight() + "px");
    } else {
        doc.style.setProperty("--adminbar-height", "0px");
    }

    const rootStyles = getComputedStyle(doc);
    mobileMenuBreakpoint = parseFloat(rootStyles.getPropertyValue("--mobile-menu-breakpoint").trim());
};
window.addEventListener("resize", cssVars);
setTimeout(() => {
    cssVars();
}, 500);

var fancyboxL10nCS = {
    CLOSE: "Zavřít",
    NEXT: "Další",
    PREV: "Předchozí",
    MODAL: "Obsah lze zavřít klávesou ESC",
    ERROR: "Požadovaný obsah se nepodařilo načíst. Zkuste to prosím později.",
    IMAGE_ERROR: "Obrázek nenalezen",
    ELEMENT_NOT_FOUND: "HTML element nenalezen",
    AJAX_NOT_FOUND: "Chyba při načítání AJAX: nenalezeno",
    AJAX_FORBIDDEN: "Chyba při načítání AJAX: zakázáno",
    IFRAME_ERROR: "Chyba při načítání stránky",
    TOGGLE_ZOOM: "Přepnout přiblížení",
    TOGGLE_THUMBS: "Přepnout náhledy",
    TOGGLE_SLIDESHOW: "Přepnout slideshow",
    TOGGLE_FULLSCREEN: "Přepnout celou obrazovku",
    DOWNLOAD: "Stáhnout",
};

function copyCurrentUrl(button) {
	const url = window.location.href;
	navigator.clipboard.writeText(url).then(() => {
        button.classList.add('ok');

        setTimeout(() => {
			button.classList.remove('ok');
		}, 1000);
	}).catch(err => {
		console.error('Kopírování se nezdařilo:', err);
		alert('Nepodařilo se zkopírovat odkaz.');
	});
}

jQuery(document).ready(function ($) {
    window.$root = $("html, body");

    // iCheck
    $("input[type='radio'], input[type='checkbox']").iCheck({});

    // iCheck suppresses native change events — GF conditional logic needs them.
    $("input[type='radio'], input[type='checkbox']").on('ifChanged', function() {
        $(this).trigger('change');
    });

    $('body').on('click', '.icheckbox, .iradio', function(e) {
        $(this).find("input").iCheck("toggle"); // Přepne stav checkboxu
	});

    // Autoscroll when url contains some hash and target exists
    // if (location.hash && $(location.hash).length > 0) {
    //     window.scrollTo(0, 0);
    //     setTimeout(function () {
    //         window.scrollTo(0, 0);
    //         let minus = 0;
    //         animateScroll($(location.hash), $(".site-header").outerHeight() + minus);
    //     }, 1);
    // }

    // Gravity forms
    // - action when form loaded (e.g. on page load, after submit attempt)
    $(document).on('gform_post_render', function(event, form_id) {
        var $form = $('#gform_' + form_id);

        // Re-initialize iCheck after GF re-renders the form (e.g. validation error)
        $form.find("input[type='radio'], input[type='checkbox']").iCheck({});
        $form.find("input[type='radio'], input[type='checkbox']").on('ifChanged', function() {
            $(this).trigger('change');
        });
    });
    // - action when form successfully submitted
    // Push GTM dataLayer event with form id/name (mapping z GF form title,
    // viz inc/forms/gravity-forms.php -> theme_gform_dataLayer_names()).
    // Všechny formuláře běží přes AJAX, takže tenhle event pokryje submit
    // na libovolném kroku vícestránkového formuláře (pouze finální submit).
    $(document).on('gform_confirmation_loaded', function(event, formId){
        window.dataLayer = window.dataLayer || [];

        var formNames = (typeof themeGformNames !== 'undefined') ? themeGformNames : {};
        var formName = formNames[formId] || ('Form ' + formId);

        window.dataLayer.push({
            event: 'gravity_form_submit',
            form_id: formId,
            form_name: formName
        });
    });

    // Contact click tracking (telefon/e-mail)
    // Delegovaný listener na všechny tel:/mailto: odkazy v šabloně (hlavička,
    // mobilní menu, mega-menu Servis, patička, CTA blok, stránka Kontakty).
    // Atributy data-contact-location/data-region/data-obchodnik jsou přímo
    // v markupu (viz template-parts/site-header/site-header-v2.php, footer.php,
    // blocks/cta-kontakt/cta-kontakt.php, page-templates/kontakt.php).
    // Metoda (phone/email) se odvozuje z prefixu href, ne z atributu.
    $(document).on('click', 'a[href^="tel:"], a[href^="mailto:"]', function () {
        window.dataLayer = window.dataLayer || [];

        var href = this.href || '';
        var method = href.indexOf('mailto:') === 0 ? 'email' : 'phone';

        window.dataLayer.push({
            event: 'contact_click',
            method: method,
            location: this.getAttribute('data-contact-location') || '',
            region: this.getAttribute('data-region') || '',
            obchodnik: this.getAttribute('data-obchodnik') || ''
        });
    });

    // Document download tracking (Dokumentace tab na produktu + stránka
    // Technická dokumentace). data-doc-type je na samotném odkazu,
    // data-product-id/data-product-name na obalujícím #product-tabs
    // (single-produkt.php), nebo na <tr> dané řádky (technicka-dokumentace.php).
    $(document).on('click', '.produkt-v2__doc-row a, .doc-table__download', function () {
        window.dataLayer = window.dataLayer || [];

        var $link = $(this);
        var $productCtx = $link.closest('#product-tabs, tr');

        window.dataLayer.push({
            event: 'document_download',
            doc_type: this.getAttribute('data-doc-type') || '',
            product_id: $productCtx.data('product-id') || '',
            product_name: $productCtx.data('product-name') || '',
            source: $link.closest('#product-tabs').length ? 'produkt' : 'technicka-dokumentace'
        });
    });

    // Reference – klik na kartu reference (výpis /reference/) nebo na kartu
    // souvisejícího produktu (na single reference stránce). Atributy
    // data-mainterm/data-subterm/data-product-type jsou na .ref-card (viz
    // template-parts/reference-card.php), data-product-id/data-product-name
    // na .ref-prod-card (viz single-reference_post.php). Filtr na výpisu
    // se řeší zvlášť v assets/js/pages/reference-new.js.
    $(document).on('click', '.ref-card, .ref-prod-card', function () {
        window.dataLayer = window.dataLayer || [];

        var $card = $(this);
        var isRelatedProduct = $card.hasClass('ref-prod-card');

        window.dataLayer.push({
            event: 'reference_interaction',
            type: isRelatedProduct ? 'related_product_click' : 'card_click',
            mainterm: this.getAttribute('data-mainterm') || '',
            subterm: this.getAttribute('data-subterm') || '',
            product_type: this.getAttribute('data-product-type') || '',
            product_id: this.getAttribute('data-product-id') || '',
            product_name: this.getAttribute('data-product-name') || ''
        });
    });

    // Produktová karta v listingu /produkty/ (statický i AJAX „Načíst další"
    // výpis sdílí stejnou šablonu template-parts/produkt-card-new.php).
    // Omezeno na #produkty-new-grid, ať se nepočítá i related-products blok
    // na jiných stránkách (ten používá stejnou .product-card-new šablonu).
    // Filtr a „Načíst další" se řeší zvlášť (taxonomy-produkt-kategorie.php/.js).
    $(document).on('click', '#produkty-new-grid .product-card-new', function () {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'product_list_interaction',
            type: 'card_click',
            product_id: this.getAttribute('data-product-id') || '',
            product_name: this.getAttribute('data-product-name') || ''
        });
    });

    // Fancybox v5 – obrázky v textovém obsahu (přidá data-fancybox atribut)
    $("#textPage a").filter(function () {
        var href = $(this).attr("href") || "";
        return href.match(/\.(jpg|jpeg|gif|png|bmp|webp)$/i);
    }).attr("data-fancybox", "textpage");

    // Fancybox v5 – WP galerie (.wp-block-gallery), každá galerie tvoří samostatnou skupinu
    $(".wp-block-gallery").each(function (i) {
        var groupName = "wp-gallery-" + i;
        $(this).find("a").filter(function () {
            return ($(this).attr("href") || "").match(/\.(jpg|jpeg|gif|png|bmp|webp)(\?.*)?$/i);
        }).each(function () {
            $(this).attr("data-fancybox", groupName);
            var caption = $(this).closest("figure").find("figcaption").text();
            if (caption) {
                $(this).attr("data-caption", caption);
            }
        });
    });

    // Fancybox v5 – inicializace pro všechny [data-fancybox] elementy
    if (typeof Fancybox !== "undefined") {
        Fancybox.bind("[data-fancybox]", {
            Hash: false,
            l10n: fancyboxL10nCS,
        });
    }

    // manage animated scrolling
    $("body").on("click", "[data-scrollto]", function (e) {
        e.preventDefault();

        var $target = $($(this).attr("data-scrollto"));
        var minus = $(this).attr("data-scrollto-minus");
        if (minus == null) minus = 0;

        animateScroll($target, minus);

        return false;
    });

    // animated scroll for anchor links
    $("a[href^='#']").not('.js-open-modal').click(function (e) {
        e.preventDefault();

        if ($(this).attr("href") != "#") {
            var $elem = $($(this).attr("href"));
            if ($elem.length > 0) {
                // Volitelný extra odstup navíc k výšce headeru (data-scroll-offset-extra
                // na CÍLOVÉM elementu, v px) — pro případy, kdy samotná výška headeru nestačí.
                var extra = parseInt($elem.attr("data-scroll-offset-extra"), 10) || 0;
                animateScroll($elem, $("header").height() + extra);
                return false;
            }
        }

        return true;
    });

    // mobile menu toggle
    $menuBtn.click(function (e) {
        e.preventDefault();
        if ($(this).hasClass("active")) {
            hideNav();
        } else {
            openNav();
        }
    });

    // mobile submenu toggle (click to expand)
    $mobileNav.find("li.menu-item-has-children").click(function (event) {
        if (!$(this).hasClass("active")) {
            event.preventDefault();
            $(this).addClass("active");
            $(this).children(".sub-menu").slideDown();
        }
    });

    // search toggle (animate width)
    $header.find(".site-header__search-wrap button[type='submit']").click(function (e) {
        var $input = $header.find(".site-header__search-wrap input[name='s']");
        var isActive = $(this).hasClass("active");
        if (!isActive || $input.val() === "") {
            e.preventDefault();
            $input.focus();
            if (isActive) {
                $(this).removeClass("active");
                $input.animate({ width: 0, "padding-left": 0, "border-width": 0 }, 600);
            } else {
                var sirka = $(window).innerWidth() < 291 ? 93 : 180;
                $(this).addClass("active");
                $input.css("border-width", "2px").animate({ width: sirka, "padding-left": 10 }, 600);
            }
        }
    });

    // Window is loaded or resized
    $(window).on("load resize", function () {
        // Wait until basic transitions ends
        setTimeout(() => {
            // equalizer
            multiEqualizer();
        }, 200);
    });

    // background images
    initBackgrounds();

    // Equalizer right when document loaded
    multiEqualizer();

    // Iframe ratio fix
    // iframeRatioFix();
});

// Header scroll – toggle body.scrolled (CSS handles visual changes)
$(document).scroll(function () {
    var scrolled = $(this).scrollTop() > 0;
    $("body").toggleClass("scrolled", scrolled);
    $header.toggleClass("with-after", scrolled);
    $("ul.products-categories").toggleClass("fixed", scrolled);
});

function initBackgrounds() {
    // background images
    $("[data-background]").each(function () {
        var bg = $(this).attr("data-background");
        if (bg.length > 0) {
            $(this).css("background-image", "url(" + bg + ")");
        }
    });
}

function animateScroll($target, minus) {
    /// <summary>
    /// Animated scrolling.
    /// </summary>
    /// <param name="$target" type="element">jQuery element to scroll to.</param>
    /// <param name="minus" type="int">Amount of pixels to decrease the position.</param>

    if (minus == null) minus = 0;

    $root.animate(
        {
            scrollTop: $target.offset().top - minus,
        },
        500,
    );
}

// This function initializes multiequalizer
// - container: data-equal="key1,key2", data-equal-on="640"
// - items: data-equal-watch="key1", data-equal-watch="key2"
function multiEqualizer() {
    $("[data-equal]").each(function () {
        var $parent = $(this),
            types = $parent.attr("data-equal").split(","),
            equalOn = $parent.attr("data-equal-on"),
            equalInRow = String($parent.attr("data-equal-in-row")).toLowerCase();

        if (typeof equalOn == "undefined" || window.innerWidth >= parseInt(equalOn)) {
            $.each(types, function (i, e) {
                // Equalize in row
                if (equalInRow === "true" || equalInRow === "1") {
                    // Current item position from top
                    let rowPosY = 0;
                    let rows = [],
                        rowItems = [],
                        rowsH = [];
                    var H = 0;

                    // Prepare array of items in row
                    // Only visible - useful when filtration
                    let items = $parent.find("[data-equal-watch=" + e + "]:visible").height("auto");

                    items.each(function () {
                        let item = $(this),
                            itemPosY = item.offset().top;
                        if (itemPosY != rowPosY) {
                            rowPosY = itemPosY;
                            // Push only nonempty array (e.g. skip the first)
                            if (rowItems.length > 0) {
                                rows.push(rowItems);
                                rowsH.push(H);
                            }

                            rowItems = [];
                            H = 0;
                        }

                        var h = $(this).height();
                        if (h > H) {
                            H = h;
                        }
                        rowItems.push(item);
                    });

                    // Add final row
                    rows.push(rowItems);
                    rowsH.push(H);
                    rows.forEach(function (row, i) {
                        let H = rowsH[i];
                        row.forEach(function (item) {
                            $(item).height(H);
                        });
                    });

                    // Equalize all
                } else {
                    var H = 0;
                    // Reset the height for proper calculation on resize
                    $parent.find("[data-equal-watch=" + e + "]").height("auto");
                    // Find the highest value
                    $parent.find("[data-equal-watch=" + e + "]").each(function () {
                        var h = $(this).height();
                        if (h > H) {
                            H = h;
                        }
                    });

                    // Set the highest value to all items
                    $parent.find("[data-equal-watch=" + e + "]").height(H);
                }
            });
        } else {
            $.each(types, function (i, e) {
                $parent.find("[data-equal-watch=" + e + "]").height("auto"); // Reset the height
            });
        }
    });
}

// This function tries to fix iframe aspect ratio
function iframeRatioFix(selector = "") {
    if (!selector) {
        // Set default selector
        selector = ".gutenberg-wrapper iframe";
    }

    // Set proper width, height & aspect ratio for iframes
    let iframes = $(selector);
    if (iframes.length > 0) {
        iframes.each(function () {
            let $iframe = $(this),
                iframeW = parseInt($iframe.attr("width")),
                iframeH = parseInt($iframe.attr("height")),
                aspectRatio;

            if (iframeW && iframeH) {
                aspectRatio = iframeW + "/" + iframeH;
            } else {
                // fallback
                aspectRatio = "500/281";
            }

            $iframe.css({
                width: "100%",
                height: "initial",
                "aspect-ratio": aspectRatio,
            });
        });
    }
}
